import CustomLogInput from './CustomInput';
import TimeInput from './TimeInput';

export const LogInput = {
  Time: TimeInput,
  Custom: CustomLogInput,
};

export default LogInput;
